import { Component, input, output } from '@angular/core';
import {
  MatCard,
  MatCardContent,
  MatCardHeader,
  MatCardSubtitle,
  MatCardTitle
} from '@angular/material/card';
import { MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { TruncatePipe } from '../../pipes';

@Component({
    selector: 'app-entity-details-dialog',
    imports: [
        MatCardContent,
        MatCardHeader,
        MatCardSubtitle,
        MatCardTitle,
        MatDialogClose,
        MatIcon,
        MatIconButton,
        MatCard,
        TruncatePipe
    ],
    templateUrl: './entity-details-dialog.component.html',
    styleUrl: './entity-details-dialog.component.scss'
})
export class EntityDetailsDialogComponent {
  title = input<string>();
  subtitle = input<string>();
  icon = input<string>();
  type = input<string>();

  readonly delete = output<void>();
  readonly edit = output<void>();

  editEntity() {
    this.edit.emit();
  }

  deleteEntity() {
    this.delete.emit();
  }
}
